import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo',
  standalone: false
})
export class LimitToPipe implements PipeTransform {
  public transform(value: string | any[], limit: number, replaceText = ''): string | any[] {
    if (typeof (value) === 'string') {
      return `${value.slice(0, limit)}${value.length > limit ? replaceText : ''}`;
    }

    return value.slice(0, limit);
  }
}
